module.exports = __webpack_public_path__ + "img/spirometry.77ad24b7.svg";